'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.media = exports.isDeviceSize = exports.breakingpoints = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _templateObject = _taggedTemplateLiteral(['\n      @media (max-width: ', 'px) {\n        ', ';\n      }\n    '], ['\n      @media (max-width: ', 'px) {\n        ', ';\n      }\n    ']);

var _styledComponents = require('styled-components');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var breakingpoints = exports.breakingpoints = {
  l: 1440,
  m: 1024,
  s: 768
};

var isDeviceSize = exports.isDeviceSize = function isDeviceSize(size) {
  return !!breakingpoints[size] && (0, _jquery2.default)(window).width() <= breakingpoints[size];
};

var media = exports.media = Object.keys(breakingpoints).reduce(function (combined, point) {
  return _extends({}, combined, _defineProperty({}, point, function () {
    return (0, _styledComponents.css)(_templateObject, breakingpoints[point], _styledComponents.css.apply(undefined, arguments));
  }));
}, {});